module.exports = __webpack_public_path__ + "img/css.ee8bbf63.svg";